export default __webpack_public_path__ + "static/media/ic_text-align-center.573c8dc0.svg";